import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import "./FanBaseHomeStar.css";

const FanBaseHomeStar = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  let { slug } = useParams();

  const [allFanPost, setAllFanPost] = useState([]);

  useEffect(() => {
    axios.get(`/api/star/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setAllFanPost(res.data?.allFanPost);
      }
    });
  }, [slug]);

  if (props.checkApproveReal) {
    axios.get(`/api/star/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setAllFanPost(res.data?.allFanPost);
      }
    });
  }

  return (
    <>
      {/* <div className="card card-bg mt-4">
        <div className="card-body">
          <div className=" row">
            <label className="col-sm-2 col-form-label">Create post</label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control fan-input"
                id="inputPassword"
                placeholder="type here for create post ...."
              />
            </div>
          </div>
        </div>
      </div> */}

      <div className="container-lg">
        <div className="parent-divFan">
          <div className="child-divFan">
            {allFanPost.map((post, i) => (
              <div className="card card-bg postFancard my-4" key={i}>
                <div className="card-body">
                  <div className="d-flex">
                    <img
                      src={imageCdnUrl + post.user?.image}
                      className="img-fluid mx-2"
                      alt=""
                      style={{ height: "40px", width: "40px" }}
                    />
                    <div className="">
                      <h6 className="m-0 ">
                        {post.user?.first_name} {post.user?.last_name}
                      </h6>
                      <small
                        className="smallDisplayChange"
                        style={{ color: "#A7A7A7" }}
                      >
                        <span className="mx-1">
                          {moment(post.created_at).format("LT")}{" "}
                        </span>{" "}
                        <span className="mx-1">
                          {moment(post.created_at).format("LL")}
                        </span>{" "}
                        <span className="mx-1">{post?.star_name}</span>
                      </small>
                    </div>
                  </div>

                  <div className="my-2">
                    <p className="text-light">{post?.description}</p>

                 
                    {post?.image ? 
                      <img
                        src={imageCdnUrl + post?.image}
                        className="img-fluid w-100"
                        alt=""
                      />
                      :
                      <ReactPlayer
                        className="form-control VideoPlays"
                        url={videoCdnUrl + post?.video}
                        autoplay
                        controls="true"
                        style={{maxWidth:"100%"}}
                      />

                    }

                    <div className="my-3"></div>
                  </div>

                  <div className=" my-2">
                    <button
                      className="btn text-warning btn-secondary fan-button "
                      style={{ width: "100%" }}
                    >
                      <i className="fa-solid fa-heart mx-1"></i>
                      {JSON.parse(post?.user_like_id).length} Likes
                    </button>
                    {/* <button className="btn  btn-secondary fan-button mx-2">
                      <i className="fa-solid fa-comment mx-1"> </i>Comments
                    </button>
                    <button className="btn  btn-secondary  fan-button mx-2">
                      <i className="fa-solid fa-share mx-1"></i>Share
                    </button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FanBaseHomeStar;
